import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@material-ui/core/Icon';

import {
  Container,
  Header,
  Left,
  QuantityText,
  Text,
  Ampoules,
} from './styles';

function QuantityItem({ used, quantity }) {
  return (
    <Container>
      <Header>
        <Left>
          <Icon className="icon-options" />
          <QuantityText bold>Quantidade/Restante</QuantityText>
        </Left>
        <Text>
          {used + quantity}/{quantity}
        </Text>
      </Header>

      <Ampoules>
        {[...Array(used).keys()].map((index) => (
          <Icon
            key={`u:${index.toString()}`} // u: used
            className="icon-ampoule used"
          />
        ))}
        {quantity > 0 &&
          [...Array(quantity).keys()].map((index) => (
            <Icon
              key={`n:${index.toString()}`} // n: not used
              className="icon-ampoule"
            />
          ))}
      </Ampoules>
    </Container>
  );
}

QuantityItem.propTypes = {
  used: PropTypes.number,
  quantity: PropTypes.number,
};

QuantityItem.defaultProps = {
  used: 0,
  quantity: 0,
};

export default QuantityItem;
